import { useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import SearchParamGenerator from "../../Utils/SearchParamGenerator";
import { Grid, Typography } from "@mui/material";
import { displayRazorpay } from "./PaymentGateways/RazorPayGateway";
import { PayUGateway } from "./PaymentGateways/PayUGateway";
import HdfcCollectNow from "./PaymentGateways/HdfcCollectNow";
import { PaytmGateway } from "./PaymentGateways/PaytmGateway";
import { PaytmGatewayNewMethod } from "./PaymentGateways/PaytmGatewayNewMethod";
import MyCard from "../../Utils/MyCard";
import MyButton from "../../Utils/MyButton";
import { LoadingProgressIcon } from "../LoadingProgressIcon";

const CheckoutPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();

  function buildForm({ action, params }) {
    const form = document.createElement("form");
    form.setAttribute("method", "post");
    form.setAttribute("action", action);

    Object?.keys(params)?.forEach((key) => {
      const input = document.createElement("input");
      input.setAttribute("type", "hidden");
      input.setAttribute("name", key);
      input.setAttribute("value", stringifyValue(params[key]));
      form.appendChild(input);
    });
    return form;
  }

  function isDate(val) {
    // Cross realm comptatible
    return Object.prototype.toString.call(val) === "[object Date]";
  }

  function isObj(val) {
    return typeof val === "object";
  }
  function stringifyValue(val) {
    if (isObj(val) && !isDate(val)) {
      return JSON.stringify(val);
    } else {
      return val;
    }
  }
  function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const HandleCallPaymentFormPage = async () => {
    const params = new URLSearchParams(searchParams);
    if (!params) {
      navigate("/auth");
      return;
    }
    let obj = {};
    params.forEach((value, key) => {
      obj[key.trim()] = value;
    });

    const base_url = obj?.base_url || obj?.baseUrl;
    const submitted = obj?.submitted;
    const back_url = obj?.back_url;
    const regFormNo = location.state;
    if (!back_url) return navigate(-1, { replace: true });
    if (submitted) return navigate(back_url, { replace: true });

    //navigating to different payment gateways
    obj.submitted = true;
    setSearchParams(SearchParamGenerator(obj));
    await delay(2000);

    delete obj?.back_url;
    delete obj.submitted;

    if (obj?.PAYMENT_GATEWAY == "Paytm") {
      delete obj?.PAYMENT_GATEWAY;
      return PaytmGateway(obj);
    } else if (obj?.PAYMENT_GATEWAY == "PaytmNewMethod") {
      delete obj?.PAYMENT_GATEWAY;

      // NEW FLOW: Check for TXN_TOKEN instead of CHECKSUMHASH
      if (!obj.txnToken) {
        alert(
          "Payment initialization failed. TXN_TOKEN not received from backend."
        );
        return;
      }

      if (!obj.orderId || !obj.amount) {
        alert("Invalid payment details. Please try again.");
        return;
      }

      // Call NEW Paytm Gateway
      return PaytmGatewayNewMethod(obj);
    } else if (obj?.PAYMENT_GATEWAY == "PayU") {
      delete obj?.PAYMENT_GATEWAY;
      return PayUGateway(obj);
    } else if (obj?.PAYMENT_GATEWAY == "Razorpay") {
      return displayRazorpay(
        { ...obj, back_url, ...regFormNo },
        JSON.parse(obj.USER_DATA),
        navigate
      );
    } else if (obj?.PAYMENT_GATEWAY == "ICICI") {
      const ENCRYPTED_URL = obj.encryptedURL?.split("@").join("&");
      return window.location.replace(ENCRYPTED_URL);
    } else if (obj?.PAYMENT_GATEWAY == "HdfcCollectNow") {
      const userData = obj.USER_DATA ? JSON.parse(obj.USER_DATA) : {};
      return HdfcCollectNow({ ...obj, back_url, ...regFormNo }, userData);
    }
    // ---------------------------------------------------------

    delete obj.base_url;
    delete obj.USER_DATA;

    const form = buildForm({
      action: `${base_url}?${SearchParamGenerator(obj)}`,
      params: obj,
    });
    document.body.appendChild(form);
    form.submit();
    form.remove();
  };

  useEffect(() => {
    HandleCallPaymentFormPage();
  }, []);

  if (searchParams?.get("PAYMENT_GATEWAY") != "Razorpay") {
    const myInterval = setInterval(() => {
      if (location.pathname == "/checkout") {
        navigate(searchParams?.get("back_url"), { replace: true });
      } else {
        clearInterval(myInterval);
      }
    }, 6000);
  }

  if (searchParams?.get("PAYMENT_GATEWAY") == "Razorpay") {
    return (
      <Grid
        sx={{
          display: "flex",
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          mt: "50px",
        }}
      >
        <MyCard
          sx={{
            p: "10px",
            mb: "10px",
            // width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            alignContent: "center",
            bgcolor: "background.card3",
            maxWidth: "70%",
          }}
        >
          <Grid
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                fontWeight: "600",
                color: "text.primary",
                fontSize: "13px",
                p: "10px",
              }}
            >
              Click the &quot;Home Screen&quot; button to go to your home
              screen.
            </Typography>
            <MyButton
              onClick={() => {
                if (window?.paymentChannel) {
                  window.paymentChannel.postMessage(
                    JSON.stringify({
                      status: "FAILURE",
                      action: "Close",
                    })
                  );
                } else {
                  navigate("/");
                }
              }}
            >
              Home Screen
            </MyButton>
          </Grid>
        </MyCard>
      </Grid>
    );
  }
  return (
    <Grid
      sx={{
        display: "flex",
        width: "100%",
        height: "300px",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <LoadingProgressIcon />
    </Grid>
  );
};

export default CheckoutPage;
